import {apiService} from "features/jwt/apiService";
import {apiErrorFrom} from "features/errors";
import {ResidenceExplorerResponse, ResidenceExternalLinkerResponse} from "features/residenceExplorer/types";
import {ResidenceExplorerServiceEndpoints} from "features/residenceExplorer/services/config";

export class ResidenceExplorerService {
    public static readonly getData = async (stageId: string) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.get<ResidenceExplorerResponse>(ResidenceExplorerServiceEndpoints.getData(stageId));

        if(error || !data) {
            throw apiErrorFrom({ error: error ?? "Failed to fetch residence explorer data", endpoint, statusCode, method, transportError });
        }

        return data;
    }

    public static readonly getExternalData = async (stageId: string) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.get<ResidenceExternalLinkerResponse>(ResidenceExplorerServiceEndpoints.getExternalData(stageId));

        if(error || !data) {
            throw apiErrorFrom({ error: error ?? "Failed to fetch residence explorer data from external linkers.", endpoint, statusCode, method, transportError });
        }

        return data;
    }
}
